import { PeriodDisplay } from "@arelia-utils/constants/constants";

const getMenuItems = <T extends Record<string, PeriodDisplay>>(
  enumObject: T
) => {
  return Object.entries(enumObject).map(([key, value]) => ({
    label: value.dropDownDisplay,
    value: key as keyof T,
  }));
};

export default getMenuItems;
